import {
  getStorefrontsClient,
  makeOptionallyAuthenticatedQuery,
} from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'

const ONE_DAY_MS = 24 * 60 * 60 * 1000

// The set of storefront ids the "New Seller" listing-card tag and the bid /
// buy-now tracking read through `newSellerStorefrontsQuery` on the client.
// The homepage New Sellers carousel no longer uses it; that carousel asks the
// search service for `newSeller=true` directly. withServerRequestCache is
// intentionally omitted: nothing calls this from a server component, so
// React.cache deduplication would have nothing to dedupe. If an RSC call site
// is added, reconsider wrapping with withServerRequestCache.
const fetchNewSellerStorefronts = async (
  accessToken: string | null
): Promise<Set<string>> => {
  const client = getStorefrontsClient()
  const response = await client.findAllStoreFronts(
    { newSeller: true, limit: 100 },
    buildAxiosRequestConfig({ accessToken })
  )
  return new Set(
    response.data.storeFronts
      .map((sf) => sf._id)
      .filter((id): id is string => Boolean(id))
  )
}

const newSellerStorefrontsQuery = makeOptionallyAuthenticatedQuery<
  [],
  Set<string>
>('new-seller-storefronts', fetchNewSellerStorefronts, {
  staleTime: ONE_DAY_MS,
  gcTime: ONE_DAY_MS,
})

export default newSellerStorefrontsQuery
